import React from 'react'
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
export default function  PopUp({ isOpen, onClose, children }) {
      if (!isOpen) return null;
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup popup-content" onClick={e => e.stopPropagation()}>
        <button className="close-btn fade-out main-btn-circle" onClick={onClose}>X</button>
        {children}
      </div>
    </div>
  )
}